import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  TextField,
  InputAdornment,
  Box,
} from "@mui/material";
import { ChevronDown, Search } from "lucide-react";
import Image from "./Image";

export function MobileNumberDropdown({
  value: currentSelect,
  onChange: setCurrentSelect,
  countryData,
}) {
  const [search, setSearch] = useState("");
  const [anchor, setAnchor] = useState(null);

  const defaultCountryCode = 91;
  const defaultFlag =
    "https://luckywheel-staging-bucket.s3.amazonaws.com/masters/Country_Flag_Image/022ceb9b-7206-4c16-835a-69b2ed311b87.png";

  const selectedCode = currentSelect || defaultCountryCode;

  const onClick = (e) =>
    anchor ? setAnchor(null) : setAnchor(e.currentTarget);

  const select = (option) => {
    setCurrentSelect(option);
    setAnchor(null);
  };

  const validCountryData = Array.isArray(countryData) ? countryData : [];

  return (
    <>
      <IconButton
        onClick={onClick}
        edge="start"
        sx={{
          fontSize: "15px",
          color: "text.primary",
          marginRight: "10px",
          "&:hover": {
            cursor: "pointer",
          },
        }}
        disableRipple
      >
        <Image
          src={
            validCountryData.find((c) => c.country_mobile_code === selectedCode)
              ?.flag || defaultFlag
          }
          alt="flag"
          style={{
            width: "25px",
            height: "20px",
            marginRight: "8px",
          }}
        />
        +{selectedCode} <ChevronDown />
      </IconButton>
      <Menu onClose={() => setAnchor(null)} anchorEl={anchor} open={!!anchor}>
        <Box
          sx={{
            padding: "0px 10px",
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <TextField
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            size="small"
            fullWidth
            type="text"
            placeholder="Search"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
          {validCountryData
            .filter((country) =>
              country?.name?.toLowerCase().includes(search.toLowerCase())
            )
            .map((option, index) => (
              <MenuItem
                key={index}
                onClick={() => select(option)}
                sx={{ display: "flex", gap: "10px" }}
              >
                <Image
                  style={{
                    height: "20px",
                    width: "30px",
                  }}
                  src={option.flag}
                  alt="flag"
                />
                {option.printable_name}
              </MenuItem>
            ))}
        </Box>
      </Menu>
    </>
  );
}
